// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1ZZMX","inputWrap":"styles_inputWrap__81Our","input":"styles_input__2OQ8W"};